module.exports = __webpack_public_path__ + "img/5.a480b28a.jpeg";